import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from "@angular/core";
import { CommonModule } from "@angular/common";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FormsModule} from "@angular/forms";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {faPlay, faPause} from "@fortawesome/free-solid-svg-icons";
import {
  FullProblemTemplate
} from "../../../../admin/feature/contentViewer/problemTemplatePreview/problemTemplatePreview.component";

import RecordRTC from 'recordrtc';
import {interval, Observable, Subscription} from "rxjs";
import {MatProgressBar} from "@angular/material/progress-bar";

@Component({
    selector: 'audio-record',
    styleUrls: ['../../../../admin/feature/userManagement/userRoleAddEdit/userRoleAddEdit.css'],
  imports: [CommonModule, FontAwesomeModule, FormsModule, MatCheckboxModule, MatProgressBar],
    templateUrl: './audio-record.component.html'
})
export class AudioRecordComponent implements OnInit, OnDestroy  {
  @Input('problem_template') problem_template!: FullProblemTemplate
  @Input('file_extensions') extensions: string[] = []
  @Input('answer') answer?: string = ''
  @Output() answerChange = new EventEmitter<Blob>()
  @Output() onChangeEmitter = new EventEmitter<Function>()
  @Output() FileUploadChange = new EventEmitter<Function>()
  @ViewChild('audioElement', { static: false }) audioElement?: ElementRef<HTMLAudioElement>;

  faPlay = faPlay
  faPause = faPause
  recorder: any
  isRecording = false
  isPlaying = false
  record_max_seconds = -1
  count = 0
  sub: Subscription = interval(1000).subscribe(() => {
    if(this.isRecording && this.record_max_seconds > 0) {
      this.count++;
      if(this.count > this.record_max_seconds) {
        this.toggleRecording();
        this.count = 0
      }
    }
  });

  ngOnInit() {
    navigator.mediaDevices.getUserMedia({video: false, audio: true}).then(async (stream) => {
      this.recorder = new RecordRTC(stream, {
        type: 'audio'
      });
    })
    if(this.problem_template) {
      if(this.problem_template.record_max_seconds){
        this.record_max_seconds = this.problem_template.record_max_seconds
      }
    }
  }

  ngOnDestroy () {
    this.sub.unsubscribe();
  }

  toggleRecording() {
    this.isRecording = !this.isRecording
    const recording = this.isRecording

    if (recording)  {
      this.recorder.startRecording();
    }
    else
      this.recorder.stopRecording(()  => {
        let blob = this.recorder.getBlob();

        this.answerChange.emit(blob);
        this.onChangeEmitter.emit();
      })
  }

  togglePlayback() {
    this.isPlaying = !this.isPlaying
  }
}
